module.exports = __webpack_public_path__ + "img/silver.a216500d.svg";